import { call, put, select } from 'redux-saga/effects';
import Swal from 'sweetalert2';
import api from '../../../service/api';
import { SKW_PREFIX } from '../../../utils/constants';

import { loadRequest, loadSuccess, loadFailure } from './actions';

export function* loadOrdemCarga({ payload }: ReturnType<typeof loadRequest>): any {
  try {
    const state = yield select();
    const response = yield call(
      api.post,
      `call?serviceName=${SKW_PREFIX}criaOrdemCarga&pagina&token=${state.auth.token}`,
      {
        ordemCarga: {
          tipoCarga: payload.tipoCarga,
          codTransportadora: payload.codTransportadora,
          clienteRetira: payload.clienteRetira,
          codParcMotorista: payload.codParcMotorista,
          codVeiculo: payload.codVeiculo,
          codTipVeiculo: payload.codTipVeiculo,
          codDestinatario: payload.codDestinatario,
          tipoWms: payload.tipoWms,
          assoalho: payload.assoalho,
        },
        nuNotas: payload.nuNotas,
      }
    );
    yield put(loadSuccess(response.data));
  } catch (error: any) {
    yield put(loadFailure());
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    }
    if (error.response.data.Erro) {
      Swal.fire({
        title: 'Opss...',
        html: `${error.response?.data?.Erro}`,
        icon: 'warning',
      });
    } else {
      Swal.fire({
        title: 'Opss...',
        html:
          'Ocorreu um erro ao carregar as lista de ordem de cargas, por favor atualize a página, se persistir contate o suporte técnico!.',
        icon: 'warning',
      });
    }
  }
}
